import { LinearProgress, Stack, Typography } from '@mui/material';

import AkaLogo from '../public/assets/images/haufe-akademie-logo-icon.svg';

type PageLoadingProps = {
  readonly msg: string;
  readonly withoutLogo?: boolean;
};

export const PageLoading = ({ msg }: PageLoadingProps) => (
  <Stack direction="row" alignItems="center" justifyContent="center" height="100%">
    <Stack direction="column" alignItems="center">
      <Stack direction="row" alignItems="center" spacing={2}>
        <img alt="Haufe Akademie Logo" src={AkaLogo} style={{ width: 48 }} />
        <Typography variant="headingMd" color="primary">
          Viva SAP-Adapter
        </Typography>
      </Stack>
      <LinearProgress sx={{ height: '12px', width: '100%', mt: 6 }} />
      <Typography variant="labelLg" sx={{ mt: 3 }}>
        {msg}
      </Typography>
    </Stack>
  </Stack>
);
